module.exports = __webpack_public_path__ + "static/img/light.3ad05d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light.png
// module id = zfGv
// module chunks = 1